import { YieldType } from '../../abacus/enums/yield-type.enum'
import { Yield } from '../../abacus/interfaces/yield.interface'

export const transparencyReportYields: Yield[] = [
  {
    label: 'Organization',
    property: 'submitterLabel'
  },
  {
    label: 'Submitter',
    property: 'createdByName'
  },
  {
    label: 'Reporting Period',
    property: 'reportingPeriodLabel',
    orderByProperty: 'reportingPeriod'
  },
  {
    label: 'Completion',
    property: 'completionLabel'
  },
  {
    label: 'Version',
    property: 'versionKey'
  },
  {
    label: 'Start Date',
    property: 'createdAt',
    type: YieldType.Date
  },
  {
    label: 'Publication Date',
    property: 'publishedAt',
    type: YieldType.Date
  }
]
